import { generateURL } from 'utils/helpers';
import { apiSlice } from '.';

apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    templates: builder.query({
      query: () => generateURL('/client/templates'),
      providesTags: ['account'],
      keepUnusedDataFor: 3600,
    }),
    clientGroupMembers: builder.query({
      query: () => generateURL('/client/memberships'),
      providesTags: ['account'],
      keepUnusedDataFor: 3600,
    }),
    saveVehicle: builder.mutation({
      query: (args) => ({
        url: generateURL('/client/vehicle_template/create'),
        method: 'POST',
        body: args,
      }),
    }),
    createAccount: builder.mutation({
      query: (args) => ({
        url: generateURL('/create_account'),
        method: 'POST',
        body: args,
      }),
    }),
    createVerification: builder.mutation({
      query: (args) => ({
        url: generateURL('/client/create_verification'),
        method: 'POST',
        body: args,
      }),
      invalidatesTags: ['account'],
    }),
    resendVerification: builder.mutation({
      query: ({ client_group_member_id, sent_to }) => ({
        url: generateURL(
          `/client_group_members/${client_group_member_id}/verifications/resend`
        ),
        method: 'PATCH',
        body: sent_to ? { sent_to } : {},
      }),
      invalidatesTags: ['account'],
    }),
    refreshMemberStatus: builder.mutation({
      query: ({ client_group_member_id }) => ({
        url: generateURL(
          `/client_group_members/${client_group_member_id}/verifications/status`
        ),
        method: 'GET',
      }),
      async onQueryStarted(
        { client_group_member_id },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData(
              'clientGroupMembers',
              undefined,
              (draft) => {
                const member = draft.find(
                  (m) => m.id === client_group_member_id
                );
                if (member) {
                  member.status = data.status;
                  member.expiry_date = data.expiryDate;
                }
              }
            )
          );
        } catch {
          // Error handled by caller
        }
      },
    }),
  }),
});

export const {
  useTemplatesQuery,
  useClientGroupMembersQuery,
  useSaveVehicleMutation,
  useCreateAccountMutation,
  useCreateVerificationMutation,
  useResendVerificationMutation,
  useRefreshMemberStatusMutation,
} = apiSlice;
